<!--  -->
<template>
  <div class="classification">
    <div class="classification-form">
      <el-form ref="formTool" :inline="true" style="text-align: left">
            <el-form-item>
              <el-select v-model="goodsType" style="width: 126px">
                <el-option label="自营商品" value="自营商品" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select
                @change="
                  (val) => {
                    goodsBaseChange(val);
                  }
                "
                v-model="goodsBaseName"
                style="width: 160px"
              >
                <el-option
                  v-for="(item, index) in goodsBaseTypeList"
                  :key="index"
                  :label="item.name"
                  :value="item"
                />
              </el-select>
            </el-form-item> 
  
            <el-form-item>
              <el-select
              filterable 
                @change="chooseProvince"
                v-model="provinceName"
                style="width: 160px"
              >
                <el-option
                  v-for="(item, index) in dfcTreeList"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>
  
            <el-form-item>
              <el-button size="small" @click="query()" type="primary"
                >查询</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="reset()" type="info"
                >重置</el-button
              >
            </el-form-item>
      </el-form>
      <el-form :inline="true">
        <el-form-item>
          <el-button size="small" @click="submitProductPrice()" type="primary":disabled="!isClick">保存</el-button>
        </el-form-item>
        <el-form-item>
          <el-switch
            :disabled="!isClick"
            v-model="standbyEnable" 
            @change="changeSwitch"
            :active-value="1"
            :inactive-value="0"
            >
          </el-switch>
        </el-form-item>
      </el-form>
    </div>

    <div class="tag-box">
      <!-- <div>
        全局设置  
      </div>  -->
      <div class="tag-box-item">
        地区公司划转
        <el-input
          v-model="tableTagForm.dbTransferAmount"
          class="tag-input"
          size="mini"
          onchange="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"
        ></el-input>
        元
      </div>
      <div class="tag-box-item">
        省区公司划转
        <el-input
          v-model="tableTagForm.sbTransferAmount"
          class="tag-input"
          size="mini"
          onchange="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"
        ></el-input>
        元
      </div>

      <div class="tag-box-item">
        云药库划转
        <el-input
          v-model="tableTagForm.yykTransferAmount"
          class="tag-input"
          size="mini"
          onchange="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"
        ></el-input>
        元
      </div> 

      <div class="tag-box-item">
        <el-button size="small" @click="dataSynchronize()" type="primary"
          >全局应用</el-button
        >
      </div>
     
    </div>

    <div class="content-table">
      <standByLedgerTable
        ref="self-price-table"
        :dfc-data="dfcTreeList"
        :unit-list="unitList"
        :goodsName="goodsBaseName"
        :goodsId="goodsBaseId"
      ></standByLedgerTable>
    </div>

     
  </div>
</template>

<script>
import standByLedgerTable from "./components/standByLedgerTable";
import {
  getUnit,
  goodsBaseType,
  getSelfPriceAndLedgerRule,
  getDfcTree,
} from "@/api/saleRule/productLine";

import {getStandbySaleRuleOpenTips} from "@/api/product"

export default {
  components: { standByLedgerTable },
  data() {
    return { 
      isClick:true,
      goodsType: "自营商品",
      provinceName: "湖南",
      areaList: [], 
      tableTagForm: {
        price: "",
        amount: "",
        dbTransferAmount: "",
        sbTransferAmount: "",
        goodsSkuUnit: "盒",
        amountZk: "60.00",
        yykTransferAmount:""
      },
      price: 0,
      unitList: [],

      page: {
        total: 0,
        current: 1,
        size: 20,
        pageSizes: [10, 20, 30, 50],
      },
      accountId: "",
      isAccount: false,
      dialogVisible: false,
      unitKey: 0,
      goodsBaseName: "",
      goodsBaseId: "",
      goodsBaseTypeList: [], //商品类型
      dfcTreeList: [], // 省地办组织list
      standbyEnable:0,// 开启或关闭状态 1/0
    };
  },
  computed: {},
  watch: {},
  created() {
   
  },
  mounted() {
    this.getDfcTree(); // 获取省地办组织
    this.goodsBaseType(); 
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  methods: { 
    changeSwitch(e){ 
      // console.log(e,'e')
      this.$refs["self-price-table"].changeSwitch(e); 
    },
    chooseProvince(e) { 
      this.provinceOrgCode = e;
    },
    // 切换商品下拉
    goodsBaseChange(val) { 
      this.goodsBaseId = val.goodsId;
      this.goodsBaseName = val.name;
    },
    // 获取省地办组织树
    getDfcTree() {
      getDfcTree().then((res) => {
        this.dfcTreeList = res.data;  
      });
    },
     
    // 获取自营商品列表 // 自营商品type固定传1
    goodsBaseType() {
      goodsBaseType(1).then((res) => {
        console.log(res, "res");
        if (res) {
          this.goodsBaseTypeList = res;
          this.goodsBaseId = res[0].goodsId;
          this.goodsBaseName = res[0].name; 
          setTimeout(()=>{
            this.query();
          },500)
        }
      });
    }, 

    // 批量保存设置
    submitProductPrice(node) {
      this.$refs["self-price-table"].submit();
    },

    // 全局应用 顶部设置的价格数据
    dataSynchronize() {
      if (this.tableTagForm.dbTransferAmount == "") {
        this.$message({
          message: "请输入地区公司划转",
          type: "warning",
        });
        return;
      }
      if (this.tableTagForm.sbTransferAmount == "") {
        this.$message({
          message: "请输入省区公司划转",
          type: "warning",
        });
        return;
      } 
      if (this.tableTagForm.yykTransferAmount == "") {
        this.$message({
          message: "请输入云药库划转",
          type: "warning",
        });
        return;
      } 
      
      this.$refs["self-price-table"].save(this.tableTagForm);
    },  

    handleClose() {
      this.dialogVisible = false;
    }, 
    
    // 重置
    reset() { 
      this.provinceName = "湖南";
      this.$refs["self-price-table"].init(this.provinceName);
      Object.keys(this.tableTagForm).forEach(
        (key) => (this.tableTagForm[key] = "")
      );
      this.tableTagForm.goodsSkuUnit = "盒";
      this.tableTagForm.amountZk = "60.00";
    },
    query() { 
      this.$refs["self-price-table"].init(this.provinceName);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";
.classification {
  .classification-form{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 8px;
  }
  .header {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px 0px 20px !important;
    border-bottom: 1px solid #f5f5f5;
    .font {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      text-align: left;
      color: #262626;
    }
    .el-form-item {
      margin: 0px 8px 0px 0px !important;
    }
  }
  background: white;

  .center {
    margin-top: 16px;
    padding: 0 24px;
    height: calc(100% - 131px);
  }
  .btn-warp {
    margin: 15px;
  }
  
  .addAccount {
    display: inline-block;
    font-size: 12px;
    color: #0da0a7;
  }
  
  .content-table {
    padding: 10px 20px;
  }
  .tag-input {
    width: 100px;
  }
  .tag-box {
    padding: 10px;
    background: rgba(255, 255, 0, 0.246);
    border-radius: 5px;
    font-size: 12px;
    color: #666;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .tag-box-item {
      margin-right: 10px;
    }
  }
  .unit-tag {
    cursor: pointer;
  }
  .content-box {
    margin: 10px;
    .unit {
      padding: 5px;
      border: solid 1px #eee;
      color: #333;
      border-radius: 5px;
      margin: 0 5px;
      line-height: 40px;
    }
    .unit:hover {
      background: rgb(255, 73, 73);
      color: #fff;
      cursor: pointer;
    }
    .active {
      background: rgb(255, 73, 73);
      color: #fff;
    }
  }
  .unit-box {
    display: flex;
  }
  .unit-s {
    margin: 5px;
    cursor: pointer;
    color: #000;
  }
}
</style>
